const adminModulesPermission = 'module:administration'
export const organizationAdminModulesPermission = 'module:organization-admin'
const corporateAdminModulesPermission = 'module:corporate-admin'
const endUserSiteAccessPermission = 'site:end-user-site-access'
export const dealerSiteAccessPermission = 'site:dealer-site-access'
const colteneSiteAccessPermission = 'site:coltene-site-access'
export const noSiteAccessPermission = 'site:no-access'
const notificationsPermission = 'page:notifications'
const storePermission = 'page:store'
const instrumentTrackingPermission = 'page:instrument-tracking'
export const myOrganizationPermission = 'page:my-organization'
export const firmwarePermission = 'page:firmware'
export const productsPermission = 'page:products'
export const troubleshootPermission = 'page:troubleshoot'
const documentProtectedPermission = 'document:protected'
export const usersWritePermission = 'users:write'
export const rolesWritePermission = 'roles:write'
export const accountsWritePermission = 'accounts:write'
export const policyWritePermission = 'policy:write'
export const policyTypeWritePermission = 'policy-type:write'
export const adminNotificationWritePermission = 'admin-notification:write'
export const adminStoreWritePermission = 'admin-store:write'
export const servicesWritePermission = 'services:write'
export const businessRulesWritePermission = 'business-rules:write'
export const reportProblemWritePermission = 'report-problem:write'
export const videosWritePermission = 'videos:write'
export const cycleWritePermission = 'cycle:write'
export const registerProductWritePermission = 'register-product:write'
export const profileWritePermission = 'profile:write'
export const userNotificationWritePermission = 'user-notification:write'
export const userProductsWritePermission = 'user-products:write'
export const productsWritePermission = 'products:write'
export const companiesWritePermission = 'companies:write'
export const branchesWritePermission = 'branches:write'
export const membersWritePermission = 'members:write'
export const organizationRequestsWritePermission = 'organization-requests:write'
export const priceListWritePermission = 'price-list:write'
export const colteneTemplatesWritePermission = 'coltene-templates:write'
export const documentUploadWritePermission = 'document-upload:write'
export const videosUploadWritePermission = 'videos-upload:write'
export const firmwareUploadWritePermission = 'firmware-upload:write'
export const troubleshootingUploadWritePermission = 'troubleshooting-upload:write'
export const predictionsWritePermission = 'predictions:write'
export const usersDeletePermission = 'users:delete'
export const rolesDeletePermission = 'roles:delete'
export const accountsDeletePermission = 'accounts:delete'
export const policyDeletePermission = 'policy:delete'
export const policyTypeDeletePermission = 'policy-type:delete'
export const adminNotificationDeletePermission = 'admin-notification:delete'
export const adminStoreDeletePermission = 'admin-store:delete'
export const servicesDeletePermission = 'services:delete'
export const businessRulesDeletePermission = 'business-rules:delete'
export const reportProblemDeletePermission = 'report-problem:delete'
export const videosDeletePermission = 'videos:delete'
export const userNotificationDeletePermission = 'user-notification:delete'
export const enhancedEventLogPermission = 'page:enhanced_event_log'
export const advancedTroubleshootingPermission = 'page:advanced-troubleshooting'
export const productsDeletePermission = 'products:delete'
export const companiesDeletePermission = 'companies:delete'
export const branchesDeletePermission = 'branches:delete'
export const membersDeletePermission = 'members:delete'
export const organizationRequestsDeletePermission = 'organization-requests:delete'
export const colteneTemplatesDeletePermission = 'coltene-templates:delete'
export const documentUploadDeletePermission = 'document-upload:delete'
export const videosUploadDeletePermission = 'videos-upload:delete'
export const firmwareUploadDeletePermission = 'firmware-upload:delete'
export const troubleshootingUploadDeletePermission = 'troubleshooting-upload:delete'
export const bellNotificationsPermissions = 'bell-notification:read'
export const deviceNotificationsReadPermissions = 'device-notification:read'
export const unitsLanguagesWritePermissions = 'units-languages:write'
export const unitsLanguagesDeletePermissions = 'units-languages:delete'
export const productModelsWritePermissions = 'device-models:write'
export const productModelsDeletePermissions = 'device-models:delete'
export const sparepartsUploadWritePermission = 'device-models:write'
export const sparepartsUploadDeletePermission = 'device-models:delete'
export const analyticsReportsPagePermissions = 'page:cf-reports'
export const registeredDevicesReportsPagePermissions = 'page:registered-devices-reports'
export const geographicalDevicesReportsPagePermissions = 'page:geographical-devices-reports'
export const soldDevicesReportsPagePermissions = 'page:sold-devices-reports'
export const remoteAccessReportsPagePermissions = 'page:remote-access-reports'
export const registeredUsersReportsPagePermissions = 'page:registered-users-reports'
export const firmwareReportsPagePermissions = 'page:firmware-reports'
export const documentUploadPagePermissions = 'page:document-upload'
export const videosUploadPagePermissions = 'page:videos-upload'
export const firmwareUploadPagePermissions = 'page:firmware-upload'
export const troubleshootingUploadPagePermissions = 'page:troubleshooting-upload'
export const unitsLanguagesPagePermissions = 'page:units-languages'
export const productModelsPagePermissions = 'page:device-models'
export const sparepartsUploadPagePermissions = 'page:device-models'

export const hasAdminModulesPermission = (permissions) => {
  return checkPermission(permissions, adminModulesPermission)
}

export const hasOrganizationAdminModulesPermission = (permissions) => {
  return checkPermission(permissions, organizationAdminModulesPermission)
}

export const hasCorporateAdminModulesPermission = (permissions) => {
  return checkPermission(permissions, corporateAdminModulesPermission)
}

export const hasEndUserSiteAccess = (permissions) => {
  return checkPermission(permissions, endUserSiteAccessPermission)
}

export const hasDealerSiteAccess = (permissions) => {
  return checkPermission(permissions, dealerSiteAccessPermission)
}

export const hasColteneSiteAccess = (permissions) => {
  return checkPermission(permissions, colteneSiteAccessPermission)
}

export const hasNoSiteAccess = (permissions) => {
  return checkPermission(permissions, noSiteAccessPermission)
}

export const hasNotificationsPermission = (permissions) => {
  return checkPermission(permissions, notificationsPermission)
}

export const hasStorePermission = (permissions) => {
  return checkPermission(permissions, storePermission)
}

export const hasDocumentProtectedPermission = (permissions) => {
  return checkPermission(permissions, documentProtectedPermission)
}

export const hasInstrumentTrackingPermission = (permissions) => {
  return checkPermission(permissions, instrumentTrackingPermission)
}

export const hasEnhancedEventLogPermission = (permissions) => {
  return checkPermission(permissions, enhancedEventLogPermission)
}

export const hasAdvancedTroubleshootingPermission = (permissions) => {
  return checkPermission(permissions, advancedTroubleshootingPermission)
}

export const hasAnalyticsReportsPagePermissions = (permissions) => {
  return checkPermission(permissions, analyticsReportsPagePermissions)
}

export const hasRegisteredDevicesReportsPagePermissions = (permissions) => {
  return checkPermission(permissions, registeredDevicesReportsPagePermissions)
}

export const hasGeographicalDevicesReportsPagePermissions = (permissions) => {
  return checkPermission(permissions, geographicalDevicesReportsPagePermissions)
}

export const hasSoldDevicesReportsPagePermissions = (permissions) => {
  return checkPermission(permissions, soldDevicesReportsPagePermissions)
}

export const hasRemoteAccessReportsPagePermissions = (permissions) => {
  return checkPermission(permissions, remoteAccessReportsPagePermissions)
}

export const hasRegisteredUsersReportsPagePermissions = (permissions) => {
  return checkPermission(permissions, registeredUsersReportsPagePermissions)
}

export const hasFirmwareReportsPagePermissions = (permissions) => {
  return checkPermission(permissions, firmwareReportsPagePermissions)
}

export const hasDocumentUploadPagePermissions = (permissions) => {
  return checkPermission(permissions, documentUploadPagePermissions)
}

export const hasVideosUploadPagePermissions = (permissions) => {
  return checkPermission(permissions, videosUploadPagePermissions)
}

export const hasFirmwareUploadPagePermissions = (permissions) => {
  return checkPermission(permissions, firmwareUploadPagePermissions)
}

export const hasTroubleshootingUploadPagePermissions = (permissions) => {
  return checkPermission(permissions, troubleshootingUploadPagePermissions)
}

export const hasUnitsLanguagesPagePermissions = (permissions) => {
  return checkPermission(permissions, unitsLanguagesPagePermissions)
}

export const hasProductModelsPagePermissions = (permissions) => {
  return checkPermission(permissions, productModelsPagePermissions)
}

export const hasSparepartsUploadPagePermissions = (permissions) => {
  return checkPermission(permissions, sparepartsUploadPagePermissions)
}

export const hasAnyInternalReportsPermission = (userPermissions) =>
  hasAnalyticsReportsPagePermissions(userPermissions) ||
  hasRegisteredDevicesReportsPagePermissions(userPermissions) ||
  hasGeographicalDevicesReportsPagePermissions(userPermissions) ||
  hasSoldDevicesReportsPagePermissions(userPermissions) ||
  hasRemoteAccessReportsPagePermissions(userPermissions) ||
  hasRegisteredUsersReportsPagePermissions(userPermissions) ||
  hasFirmwareReportsPagePermissions(userPermissions)

export const checkPermission = (permissions, permission) => {
  return Array.isArray(permissions) && permissions.includes(permission)
}

